<div  *ngIf='!small'  class="text-center">
  <div class="spinner-border m-2 text-primary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div *ngIf='small' class="spinner-border text-primary smallSpinner text-muted " role="status">
</div> 